import React from "react";

export interface CheckboxProps {
  checked?: boolean | "indeterminate";
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  id?: string;
  disabled?: boolean;
}

export function Checkbox({
  checked,
  onCheckedChange,
  className,
  id,
  disabled,
}: CheckboxProps) {
  const isChecked = checked === true || checked === "indeterminate";

  return (
    <input
      type="checkbox"
      checked={isChecked}
      ref={(el) => {
        if (el) el.indeterminate = checked === "indeterminate";
      }}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      className={className}
      id={id}
      disabled={disabled}
    />
  );
}
